import moment from 'moment'

function taxCenter(state={
  range: [moment().startOf('year'), moment()],
  taxableIncome: 0,
  totals: {
    "total_revenue": "0.0",
    "total_expenses": "0.0",
    "total_trips_deductions": "0.0"
  }
}, action) {
  switch (action.type) {

    case "UPDATE_RANGE":
      return {
        ...state,
        range: action.range
      }

    case "UPDATE_TAX_CENTER":
      return {
        ...state,
        totals: action.totals,
        taxableIncome: getTaxableIncome(action.totals)
      }
      
    case "LOGIN_SUCCESS":
    case "USER_SUCCESS":
      const {
        total_expenses, total_revenue, total_trips_deductions
      } = action.user
      return {
        ...state,
        totals: {
          total_expenses, total_revenue, total_trips_deductions
        },
        taxableIncome: getTaxableIncome(action.user)
      }
    default:
      return state
  }
}
export default taxCenter


export const toRangeParams = (range) => {
  if (range.length<2) return {
    start_day: null,
    start_month: null,
    start_year: null,

    end_day: null,
    end_month: null,
    end_year: null,
  }

  const start = range[0]
  const end = range[1]
  return {
    start_day: start.format("D"),
    start_month: start.format("M"),
    start_year: start.format("YYYY"),

    end_day: end.format("D"),
    end_month: end.format("M"),
    end_year: end.format("YYYY"),
  }
}

export const getTaxableIncome = (totals) =>
  parseFloat(totals.total_revenue)
  + (parseFloat(totals.total_expenses) + parseFloat(totals.total_trips_deductions))



// WEBPACK FOOTER //
// ./src/account/tax-center/reducer.js